import { Paperclip, Send, X } from 'lucide-react';
import { useSupport } from '../../../../../../../context/support/SupportContext';

const TicketMessageInput = ({ selectedTicket }) => {
  const {
    ticketReplies,
    setTicketReplies,
    chatAttachment,
    setChatAttachment,
    chatAttachmentPreview,
    setChatAttachmentPreview,
    isSendingMessage,
    handleSendTicketMessage,
    handleChatAttachmentChange,
    chatFileInputRef
  } = useSupport();

  const isResolved = selectedTicket.status === 'resolved';
  const currentReply = ticketReplies[selectedTicket._id] || '';

  return (
    <div className="p-3 md:p-4 border-t border-gray-200 bg-white">
      {chatAttachmentPreview && (
        <div className="mb-3 relative inline-block">
          <img
            src={chatAttachmentPreview}
            className="h-16 w-16 object-cover rounded-lg border border-gray-200"
            alt="Preview"
          />
          <button
            onClick={() => {
              setChatAttachment(null);
              setChatAttachmentPreview(null);
            }}
            className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 shadow-md hover:bg-red-600 transition-colors cursor-pointer"
          >
            <X size={10} />
          </button>
        </div>
      )}
      <div className="flex items-center gap-2 md:gap-3">
        <button
          disabled={isSendingMessage || isResolved}
          onClick={() => chatFileInputRef.current?.click()}
          className={`p-2 transition-colors cursor-pointer ${
            isSendingMessage || isResolved
              ? 'text-gray-200 cursor-not-allowed'
              : 'text-gray-400 hover:text-[#067978]'
          }`}
        >
          <Paperclip size={20} />
        </button>
        <input
          type="file"
          ref={chatFileInputRef}
          className="hidden"
          accept="image/*"
          onChange={handleChatAttachmentChange}
          disabled={isSendingMessage || isResolved}
        />
        <input
          type="text"
          placeholder={
            isResolved
              ? 'Ticket resolved. No further messages.'
              : 'Type your message...'
          }
          value={currentReply}
          onChange={(e) =>
            setTicketReplies((prev) => ({
              ...prev,
              [selectedTicket._id]: e.target.value
            }))
          }
          onKeyDown={(e) =>
            e.key === 'Enter' && handleSendTicketMessage(selectedTicket._id)
          }
          disabled={isSendingMessage || isResolved}
          className={`flex-1 px-4 py-2.5 bg-gray-100 border-none rounded-xl text-sm outline-none focus:ring-1 focus:ring-[#067978]/30 ${
            isSendingMessage || isResolved
              ? 'opacity-50 cursor-not-allowed'
              : ''
          }`}
        />
        <button
          disabled={
            isSendingMessage ||
            isResolved ||
            (!currentReply.trim() && !chatAttachment)
          }
          onClick={() => handleSendTicketMessage(selectedTicket._id)}
          className={`p-2.5 rounded-xl transition-all cursor-pointer ${
            isSendingMessage ||
            isResolved ||
            (!currentReply.trim() && !chatAttachment)
              ? 'text-gray-300 bg-gray-100 cursor-not-allowed'
              : 'bg-[#067978] text-white shadow-sm hover:bg-teal-700'
          }`}
        >
          {isSendingMessage ? (
            <div className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full" />
          ) : (
            <Send size={18} />
          )}
        </button>
      </div>
    </div>
  );
};

export default TicketMessageInput;
